var React = require('react');

function DonateInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.3.624l.006.993c.013 1.652.013 3.835.01 5.602L9.31 9.444l-.004.898-2-.008.004-.897a1344.97 1344.97 0 00.007-5.228 525.34 525.34 0 01-5.475 5.926l-.147.155L.242 8.918l.144-.154a423.979 423.979 0 001.97-2.11 523.494 523.494 0 003.698-4.029H.052l-.001-2h9.248z","fill":"#E6E5E1"}));
}

DonateInline.defaultProps = {"width":"10","height":"11","viewBox":"0 0 10 11","fill":"none"};

module.exports = DonateInline;

DonateInline.default = DonateInline;
